import React from 'react'
import { colors } from '../../../styles/vars/colors.style'

const MapArrow = ({
  width = 18,
  height = 18,
  circleFill = colors.light,
  pathFill = colors.darkBlue,
  responsive = false,
}) => {
  const svgAttributes = responsive
    ? {}
    : {
        width,
        height,
      }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 18 18"
      focusable="false"
      role="img"
      fill="none"
      {...svgAttributes}
    >
      <circle
        cx="9.00024"
        cy="9.00011"
        r="8"
        transform="rotate(-89.7846 9.00024 9.00011)"
        fill={circleFill}
      />
      <path
        d="M12.7132 8.64845C12.9127 8.76467 12.9116 9.05334 12.7112 9.16806L7.19931 12.3228C6.99887 12.4375 6.74942 12.2922 6.75029 12.0613L6.77416 5.71048C6.77503 5.47954 7.02557 5.33614 7.22514 5.45237L12.7132 8.64845Z"
        fill={pathFill}
      />
    </svg>
  )
}

export default MapArrow
